/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { DomainDriverCompanyTargetMilestoneProgressStatus } from '../../entities/domain/DriverCompanyTargetMilestoneProgressStatus'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const domainDriverCompanyTargetMilestoneProgressStatusSchema = z.enum([
  'progress',
  'completed',
  'failed',
]) as unknown as ToZod<DomainDriverCompanyTargetMilestoneProgressStatus>